module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "banner"
  }, [_c('p', {
    staticClass: "container"
  }, [_c('span', {
    staticClass: "up"
  }, [_vm._v("关于我们")]), _vm._v(" "), _c('span', {
    staticClass: "down"
  }, [_vm._v("ABOUT US")])])]), _vm._v(" "), _c('div', {
    staticClass: "path"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._v("当前位置： 首页 > 关于我们")])]), _vm._v(" "), _c('section', {
    staticClass: "content container"
  }, [_c('div', {
    staticClass: "intro"
  }, [_c('h3', [_vm._v("简介")]), _vm._v(" "), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "detail"
  }, [_c('p', [_vm._v("极客邦科技（Geekbang）是一家世界级 IT 知识服务平台。创立于 2007 年，提供媒体、会议、电商、培训、咨询、图书、出版、社交等服务，总部设于北京。致力于让创新技术推动社会进步。十年内，极客邦科技为千万级技术人，10,000+ 中国企业提供服务，业务遍布中国各城市，以及美国、法国、德国、荷兰、以色列、日本等国家。")])]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "bg",
      "src": "https://static.geekbang.org/infoq/5aa26e58ae18f.png?imageView2/0/"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "kernel-values"
  }, [_c('h3', [_vm._v("核心价值观")]), _vm._v(" "), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "alt": "photo",
      "src": "https://static.geekbang.org/infoq/5aa26e59553af.png?imageView2/0/"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "explain"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('h4', [_vm._v("公开透明")]), _vm._v(" "), _c('h5', [_vm._v("transparency")]), _vm._v(" "), _c('p', [_vm._v("我们的工作流程、状态、期望值、个人感受、成功与失败都是公开和透明的")]), _vm._v(" "), _c('p', {
    staticClass: "after"
  }, [_vm._v("01 /")])])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "explain"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('h4', [_vm._v("诚实正直")]), _vm._v(" "), _c('h5', [_vm._v("integrity")]), _vm._v(" "), _c('p', [_vm._v("我们说到做到，也只说自己做到的。我们创作读者信赖的内容，努力实现对读者、客户和团队成员彼此之间的承诺，为公司的最大利益而努力")]), _vm._v(" "), _c('p', {
    staticClass: "after"
  }, [_vm._v("02 /")])])]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "photo",
      "src": "https://static.geekbang.org/infoq/5aa26e59bcba2.png?imageView2/0/"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "alt": "photo",
      "src": "https://static.geekbang.org/infoq/5aa26e590525d.png?imageView2/0/"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "explain"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('h4', [_vm._v("每日精进")]), _vm._v(" "), _c('h5', [_vm._v("mastery")]), _vm._v(" "), _c('p', [_vm._v("学习的脚步永不停止，持续提高自我，优化 流程和我们的公司")]), _vm._v(" "), _c('p', {
    staticClass: "after"
  }, [_vm._v("03 /")])])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "explain"
  }, [_c('div', {
    staticClass: "wrappper"
  }, [_c('h4', [_vm._v("乐于服务")]), _vm._v(" "), _c('h5', [_vm._v("service")]), _vm._v(" "), _c('p', [_vm._v("享受为他人服务的乐趣，为我们的客户、读者和团队成员彼此提供超乎所想的服务")]), _vm._v(" "), _c('p', {
    staticClass: "after"
  }, [_vm._v("04 /")])])]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "photo",
      "src": "https://static.geekbang.org/infoq/5aa26e5ad9e24.png?imageView2/0/"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "alt": "photo",
      "src": "https://static.geekbang.org/infoq/5aa26e5a13b5a.png?imageView2/0/"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "explain"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('h4', [_vm._v("负责守诺")]), _vm._v(" "), _c('h5', [_vm._v("accountability")]), _vm._v(" "), _c('p', [_vm._v("为结果负责，我们尽力完成工作，认真对待我们做出的每一个承诺")]), _vm._v(" "), _c('p', {
    staticClass: "after"
  }, [_vm._v("05 /")])])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "explain"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('h4', [_vm._v("创新敢为")]), _vm._v(" "), _c('h5', [_vm._v("resourcefulness")]), _vm._v(" "), _c('p', [_vm._v("努力找寻创造性的解决方案完成工作，时刻拥有“我能做”的态度")]), _vm._v(" "), _c('p', {
    staticClass: "after"
  }, [_vm._v("06 /")])])]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "photo",
      "src": "https://static.geekbang.org/infoq/5aa26e5a66049.png?imageView2/0/"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42ba4214","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/aboutus/aboutus.vue
// module id = 448
// module chunks = 1